import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorMessage, Form, Formik } from "formik";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../../APIs/request";
import CustomInput from "../../CustomComponent/custom_input";
import CustomSelect from "../../CustomComponent/custom_select";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { taskManagementInfo } from "../../../Schema Info/createtaskInfo";
import { CreateTaskSchema } from "../../../Schemas/Task Management/createtask_schema"
import CustomTextArea from "../../CustomComponent/custom_textarea";
import CustomRadioButton from "../../CustomComponent/custom_radio";
import { BsPatchPlus } from "react-icons/bs";
import { FcCalendar } from "react-icons/fc";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useSelector } from "react-redux";

const Createtask = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [employeeData, setEmployeeData] = useState();
  const userData = useSelector((store) => store?.user); 
   useEffect(() => {
    performRequest("GET", "/tasks/companyemployees/")
      .then((res) => setEmployeeData(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  const handleSubmit = (values, actions) => {
    const Values = {
      ...values,
      status: "pending",
    };
    setLoading(true);
    performRequest("POST", "/tasks/createtaskmanagement/", Values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Task created successfully!");
          navigate(`/task-management`);
        } else {
          Toast("error", "Error while Creating");
        }
      })
      .catch((err) => {
         console.error("Error", err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> Create New Task
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Allot & create new tasks.
                </h4>
              </div>
              <div className="col-md-4">
                {/* <div className="btn-list justify-content-end">
                  <a href={"/task-management"}>
                    <button className="btn btn-primary">
                      <BsPatchPlus className="me-2 fs-2" /> View Task List
                    </button>
                  </a>
                </div> */}
                <div className="btn-list justify-content-end">
                  {/* {(userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                    userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_SALES_MANAGER ||
                    userData?.Role === process.env.REACT_APP_ROLE_IT ||
                    userData?.Role === process.env.REACT_APP_ROLE_PURCHASE ||
                    userData?.Role === process.env.REACT_APP_ROLE_ACCOUNTS ||
                    userData?.Role === process.env.REACT_APP_ROLE_AGRONOMIST ||
                    userData?.Role === process.env.REACT_APP_ROLE_OPS ||
                    userData?.Role ===  process.env.REACT_APP_ROLE_SALLE ||
                    userData?.Role === process.env.REACT_APP_ROLE_INSPECTION ||
                    userData?.Role === process.env.REACT_APP_ROLE_MARKETING ||
                    userData?.Role === process.env.REACT_APP_ROLE_SSM ||
                    userData?.Role ===
                      process.env.REACT_APP_ROLE_CLIENT_FEEDBACK) && ( */}
                    <a href={"/task-management"}>
                      <button className="btn btn-primary">
                        <BsPatchPlus className="me-2 fs-2" /> View Task List
                      </button>
                    </a>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>Only Super Admins and Admins can Create tasks.</p>
                <p>
                  You can not allot tasks to clients or someone out of the
                  organization.
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <Formik
                  initialValues={taskManagementInfo}
                  validationSchema={CreateTaskSchema}
                  onSubmit={handleSubmit}
                >
                  {(props) => (
                    <Form>
                   
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Name
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="name" type="text" />
                            {props.touched.name && props.errors.name && (
                              <p className="text-danger">{props.errors.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Task type
                          </label>
                          <div className="w-100 col">
                            <div>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="one time"
                                />
                                <span className="form-check-label">
                                  One Time
                                </span>
                              </label>
                              <label className="form-check form-check-inline">
                                <CustomRadioButton
                                  name="taskType"
                                  value="repeat task"
                                />
                                <span className="form-check-label">
                                  Repeat Task
                                </span>
                              </label>
                            </div>
                            <ErrorMessage
                              name="taskType"
                              component="p"
                              className="text-danger"
                            />
                          </div>
                        </div>
                        {props.values.taskType !== "repeat task" && (
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3">
                              Deadline
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="deadline" type="date" />
                              <ErrorMessage
                                name="deadline"
                                component="p"
                                className="text-danger"
                              />
                            </div>
                          </div>
                        )}
                        {props.values.taskType === "repeat task" && (
                          <>
                            <div className="mb-3 row">
                              <label className="w-25 form-label required col-3">
                                Start date
                              </label>
                              <div className="w-100 col">
                                <CustomInput name="startDate" type="date" />
                                <ErrorMessage
                                  name="startDate"
                                  component="p"
                                  className="text-danger"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="w-25 form-label col-3 required">
                                Frequency
                              </label>
                              <div className="w-100 col">
                                <div className="d-flex">
                                  <CustomSelect
                                    className="me-2 form-select"
                                    name="frequency"
                                    type="text"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="">Select</option>
                                    {[...Array(32).keys()].map((month) => (
                                      <option key={month} value={month}>
                                        {month}
                                      </option>
                                    ))}
                                  </CustomSelect>
                                  <CustomSelect
                                    name="frequencyType"
                                    type="text"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="">Select Type</option>
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="year">Year</option>
                                  </CustomSelect>
                                </div>
                                {props.touched.frequencyType &&
                                  props.errors.frequencyType && (
                                    <p className="text-danger">
                                      {props.errors.frequencyType}
                                    </p>
                                  )}
                                {props.touched.frequency &&
                                  props.errors.frequency && (
                                    <p className="text-danger">
                                      {props.errors.frequency}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </>
                        )}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Assign to
                          </label>
                          <div className="w-100 col">
                                         

                            <CustomSelect name="assignTo" type="text">
                              <option value="">Select</option>
                              {employeeData &&
                                employeeData?.map((pro) => {
                                   
                                  return (
                                    <option key={pro.id} value={pro.id} >{pro.fullName}</option>
                                  );
                                })}
                            </CustomSelect>
                            {props.touched.assignTo &&
                              props.errors.assignTo && (
                                <p className="text-danger">
                                  {props.errors.assignTo}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Description
                          </label>
                          <div className="w-100 col">
                            <CustomTextArea name="description" type="text" />
                            {props.touched.description &&
                              props.errors.description && (
                                <p className="text-danger">
                                  {props.errors.description}
                                </p>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Create Task" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Createtask;
